import 'isomorphic-fetch';
import baseFetch from '../baseFetch';
import legacyApiFetch from '../legacyApiFetch';
import config from '../../config';

export const fetchReport = (spotId, cookies) =>
  baseFetch(`/kbyg/spots/reports?spotId=${spotId}`, { cookies });

export const fetchNearbySpots = (spotId, cookies) =>
  baseFetch(`/kbyg/spots/nearby?spotId=${spotId}`, { cookies });

export const fetchBuoys = async (legacySpotId, units) => {
  const url = `${config.legacyApi}/mobile/nearby/${legacySpotId}?resources=buoy&unit=${units}&buoys=6`;
  const response = await fetch(url);
  const body = await response.json();
  if (response.status > 200) throw body;
  return body;
};

export const fetchIdealConditions = legacySpotId =>
  legacyApiFetch(`/mobile/report/${legacySpotId}`);
